import { Icon } from '@toggle/design-system';
import React from 'react';

import { useUnreadAlertsCount } from '~/react-query-hooks/events/use-event-alerts/useUnreadAlertsCount';

import styles from './AlertsIcon.module.scss';

export const AlertsIcon = () => {
  const unreadCount = useUnreadAlertsCount();

  return (
    <div className={styles.alertsIconRoot}>
      <Icon iconName="NotificationLine" size={24} />
      {unreadCount > 0 && (
        <span className={styles.unreadBadge}>
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </div>
  );
};
